import { render, staticRenderFns } from "./HomeGlobalFeed.vue?vue&type=template&id=a6216450&"
import script from "./HomeGlobalFeed.vue?vue&type=script&lang=ts&"
export * from "./HomeGlobalFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports